export const environment = {
  production: false,
  baseUrl:'https://api-managment-digitalizcija.azure-api.net/bpa-app-test', // https://test-web-app-bpa-api.azurewebsites.net
  clientId: "535599d1-c9e0-4a6f-bdef-bc741a35dae6", // Application (client) ID from the app registration
  authority:"https://login.microsoftonline.com/c7223f2c-1ba2-43c8-be7f-57e6e1465036", // The Azure cloud instance and the app's sign-in audience (tenant ID, common, organizations, or consumers)
  redirectUri: "https://bpa.test.valamar.hr/auth-redirect.html", // Dedicated MSAL redirect URL (non-routed, avoids hash collision)
  postLogoutRedirectUri: "https://bpa.test.valamar.hr",
  ocpApimSubscriptionKey: "6ee35b4fa66c44178d47b3622513037e",
  apiScope: "api://535599d1-c9e0-4a6f-bdef-bc741a35dae6/access_as_user"
};
